export { FontFamily } from "@tiptap/extension-text-style/font-family";
